module.exports = __webpack_public_path__ + "media/images/iconTrendUp--dark-66438079f9d19946c657693122f9da78.png";